import {Switch, Route} from 'react-router-dom'
import React, {useState, useEffect, useRef} from 'react'
import './App.css'
import Header from './components/Header'
import Dropdown from './components/Dropdown'
import About from './Pages/About'
import Search from './Pages/Search'
import AuthorDataReverse from './components/AuthorDataReverse'
require('dotenv').config()
const App = () => {
  const onLoadOrientation =
    window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
  const autoCompleteRef = useRef(null)
  const [img, setImage] = useState('')
  const [noImage, setImg] = useState(false)
  const [description, setDescription] = useState(null)
  const [author, setAuthor] = useState({})
  const [click, setClick] = useState(false)
  const [isToggled, setIsToggled] = useState(false)
  const [unsplashLink, setUnsplashLink] = useState(null)
  const [searchQuery, setSearchQuery] = useState('')
  const [errorSearch, setErrorSearch] = useState(false)
  const [result, setResult] = useState({})
  const [errorInput, setErrorInput] = useState(false)
  const [query, setQuery] = useState({
    city: null,
    country: null,
    fullCountry: null,
    orientation: null,
  })
  const handleClick = () => setClick(!click)
  let autoComplete
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    {types: ['(cities)']},
  )
  autoComplete.setFields(['address_components', 'formatted_address'])
  autoComplete.addListener('place_changed', () => {
    const place = autoComplete.getPlace()
    if (place.address_components) {
      console.log(place.address_components)
      setErrorInput(false)
      const city = place.address_components[0].short_name
      const country =
        place.address_components[place.address_components.length - 1].short_name
      const fullCountry =
        place.address_components[place.address_components.length - 1].long_name
      setQuery({city, country, fullCountry, orientation: onLoadOrientation})
    } else if (place.name) {
      setErrorInput(true)
      setErrorSearch(false)
    }
  })
  const {city, country, fullCountry, orientation} = query
  const getWeather = async (city, country, fullCountry) => {
    if (city !== null) {
      const urlWeather = `https://weathercare-backend.vercel.app/weather?city=${city
        .normalize('NFD')
        .replace(
          /[\u0300-\u036f]/g,
          '',
        )}&country=${country}&fullCountry=${fullCountry}`
      const options = {
        // method: "POST", // *GET, POST, PUT, DELETE, etc.
        // mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
          Accept: 'application/x-www-form-urlencoded',
          // Accept: "application/json",
          'Content-Type': 'application/json',
        },
        // body: JSON.stringify({ city: city, country: country }),
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      }
      const incomingData = await fetch(urlWeather, options)
      const res = await incomingData.json()
      if (res.cod === '404') {
        setErrorSearch(true)
        setResult(res)
        setErrorInput(false)
      } else {
        const weatherIcon = res.weather
          .map(item => item.icon)
          .toString()
          .replace('n', 'd')
        const response = {...res, weatherIcon}
        setResult(response)
        setErrorSearch(false)
      }
    }
  }
  const getImage = async (city, fullCountry, orientation) => {
    orientation = onLoadOrientation
    const img_url =
      city === null
        ? `https://weathercare-backend.vercel.app/unsplashrandom?orientation=${orientation}`
        : `https://weathercare-backend.vercel.app/unsplash?city=${city}&fullCountry=${fullCountry}&orientation=${orientation}`
    const imgOptions = {
      // method: "POST", // *GET, POST, PUT, DELETE, etc.
      // mode: "no-cors", // no-cors, *cors, same-origin
      headers: {
        Accept: 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json',
      },
      // body: JSON.stringify({
      //   city: city,
      //   fullCountry: fullCountry,
      //   orientation: onLoadOrientation,
      // }),
      redirect: 'manual', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }
    const incomingImg = await fetch(img_url, imgOptions)
    const getImage = await incomingImg.json()
    console.log(getImage)
    incomingImg.status !== 404 ? setImage(getImage.urls) : setImg(true)
    setUnsplashLink(getImage.links.html)
    setAuthor(getImage.user)
    setDescription(getImage.description)
  }
  useEffect(() => {
    getImage(city, fullCountry, orientation)
    getWeather(city, country, fullCountry)
  }, [query])
  const {regular} = img
  const unsplashBackgroundImg = {
    backgroundImage: `url(${regular})`,
    backgroundSize: 'cover',
    height: '100vh',
    margin: '0',
    padding: '0',
    display: 'flex',
    overflow: 'hidden',
    backgroundPositionX: 'center',
    backgroundAttachment: 'fixed',
    zIndex: -1,
  }
  const {
    name,
    username,
    instagram_username,
    twitter_username,
    links,
    portfolio_url,
  } = author
  return (
    <div
      className="App min-h-screen flex items-center justify-center"
      style={unsplashBackgroundImg}
    >
      <div
        className="layout flex grid grid-rows-16 h-screen w-screen lg:p-6"
        style={{background: 'inherit'}}
      >
        <div className="row-span-2 md:flex md:items-center">
          <Header click={click} handleClick={handleClick} />
        </div>
        <Switch>
          <Route exact path={['/', '/search']}>
            <Search
              click={click}
              handleClick={handleClick}
              name={name}
              links={links}
              username={username}
              instagram_username={instagram_username}
              twitter_username={twitter_username}
              img={img}
              portfolio_url={portfolio_url}
              autoCompleteRef={autoCompleteRef}
              isToggled={isToggled}
              setIsToggled={setIsToggled}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              errorSearch={errorSearch}
              errorInput={errorInput}
              setErrorInput={setErrorInput}
              result={result}
              description={description}
              unsplashLink={unsplashLink}
            />
          </Route>
          <Route path="/about">
            <div className="row-span-2 lg:hidden">
              <Dropdown click={click} handleClick={handleClick} />
            </div>
            <div className="row-span-11">
              <About />
            </div>
            <div className="row-span-2"></div>
            <div className="row-span-1 hidden sm:hidden md:hidden lg:flex lg:mb-5">
              <AuthorDataReverse
                name={name}
                links={links}
                username={username}
                instagram_username={instagram_username}
                twitter_username={twitter_username}
                rawImage={img}
                portfolio_url={portfolio_url}
                unsplashLink={unsplashLink}
              />
            </div>
          </Route>
        </Switch>
      </div>
    </div>
  )
}
export default App